import { createSlice } from '@reduxjs/toolkit'
import { fileUrl } from 'src/utils/lib'
import { initialState } from './model'
import { fetchMyEnrollProfile } from '../../../../services/class/registration'
import { USER_TYPE } from 'src/modules/EExamination/constant'
import _ from 'lodash'

const classEnroll = createSlice({
  name: 'classEnroll',
  initialState,
  reducers: {
    setProgress: (state, { payload }) => {
      state.progress = payload
    },
    resetEnrollData: (state) => {
      state.enrollProps = null
      state.socketId = null
    },
    setEnrollData: (state, { payload }) => {
      state.enrollProps = payload.enrollProps
      state.socketId = payload.socketId
    },
    setSocketId: (state, { payload }) => {
      state.socketId = payload
    },
    setFormNextButtonDisabled: (state, { payload }) => {
      const { index, value } = payload
      state.formNextButtonDisabled[index] = value
    },
    setReduxValue: (state, { payload }) => {
      const { index, value } = payload
      state[index] = value
    },
    setOptions: (state, { payload }) => {
      const { index, value } = payload
      state.options[index] = value
    },
    setEnrollFormError: (state, { payload }) => {
      const { index, value } = payload
      state.enrollFormError[index] = value
    },
    setFormError: (state, { payload }) => {
      const { index, value } = payload
      state.formError[index] = value
    },
    addEnroll: (state) => {
      const { enroll, selectedEnrollList } = state
      state.enroll = [...enroll, ...selectedEnrollList]
    },
    removeEnroll: (state, { payload }) => {
      const { enroll } = state
      const { index } = payload
      let newEnroll = [...enroll]
      newEnroll.splice(index, 1)
      state.enroll = newEnroll
    },
    setEnrollDetail: (state, { payload }) => {
      const { index, obj, value } = payload
      state.enroll[index][obj] = value
    },
    setImage: (state, { payload }) => {
      const { index, cardImage, imageName, fileName, key, fileSize, fileType } =
        payload
      const imgObj = {
        cardImage,
        imageName,
        fileName,
        key,
        fileSize,
        fileType,
      }
      state.enroll[index].cardImage = imgObj
      state.enroll[index].imageName = imageName
    },
    setConsent: (state, { payload }) => {
      state.consent = payload
    },
    removeIdcard: (state, { payload }) => {
      const { index } = payload
      state.enroll[index].cardImage = ''
      state.enroll[index].imageName = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyEnrollProfile.fulfilled, (state, { payload }) => {
        const userImageUrl = payload.userImage
          ? fileUrl(payload.userImage)
          : '/logo/staff_profile_small.png'
        const type = payload?.type || 'TEMP'
        const isCanEditProfile = payload?.isCanEditProfile || false

        // Helper function to check if field has value
        const hasValue = (value) => value && value.trim() !== ''

        // Get user type from localStorage to determine role
        // Use userType from localStorage only, don't fallback to type from payload
        const user = JSON.parse(window.localStorage.getItem('user') || '{}')
        const userTypeLocal = user?.userType
        const staffType = _.get(user, 'staffProfile.type', null)
        const isAgent = userTypeLocal === 'AGENT'
        const isStaffAcademy =
          userTypeLocal === 'STAFF' && staffType !== 'NON_ACADEMY'
        const isStaffNonAcademy =
          userTypeLocal === 'STAFF' && staffType === 'NON_ACADEMY'

        // Determine editable state based on role requirements
        let editable = {}

        if (isAgent) {
          // Agent: Only prefixTH editable if no value (first time), other fields not editable
          editable = {
            isEditPrefixTH: !hasValue(payload?.prefixTH),
            isEditName: false,
            isEditSurname: false,
            isEditPrefix: !hasValue(payload?.prefix),
            isEditNameEN: false,
            isEditSurnameEN: false,
            isEditIdCardNo: false,
            isEditMobile: false,
            isEditBirthDate: false,
          }
        } else if (isStaffAcademy) {
          // Staff Academy: ID Card and DOB editable only if no value, other fields editable only if no value
          editable = {
            isEditPrefixTH: !hasValue(payload?.prefixTH),
            isEditName: !hasValue(payload?.firstNameTH),
            isEditSurname: !hasValue(payload?.lastNameTH),
            isEditPrefix: !hasValue(payload?.prefix),
            isEditNameEN: !hasValue(payload?.firstName),
            isEditSurnameEN: !hasValue(payload?.lastName),
            isEditIdCardNo: !hasValue(payload?.idCardNo),
            isEditMobile: !hasValue(payload?.mobileNo),
            isEditBirthDate: !hasValue(payload?.dateOfBirth),
          }
        } else if (isStaffNonAcademy) {
          // Staff Non Academy: All fields editable only if no value
          editable = {
            isEditPrefixTH: !hasValue(payload?.prefixTH),
            isEditName: !hasValue(payload?.firstNameTH),
            isEditSurname: !hasValue(payload?.lastNameTH),
            isEditPrefix: !hasValue(payload?.prefix),
            isEditNameEN: !hasValue(payload?.firstName),
            isEditSurnameEN: !hasValue(payload?.lastName),
            isEditIdCardNo: !hasValue(payload?.idCardNo),
            isEditMobile: !hasValue(payload?.mobileNo),
            isEditBirthDate: !hasValue(payload?.dateOfBirth),
          }
        } else {
          // Default: For Prospect and other types - editable if no data or if can edit profile
          editable = {
            isEditPrefixTH:
              (type === USER_TYPE.AGENT && !hasValue(payload?.prefixTH)) ||
              (type !== USER_TYPE.AGENT &&
                (!hasValue(payload?.prefixTH) || isCanEditProfile)),
            isEditName:
              type !== USER_TYPE.AGENT &&
              (!hasValue(payload?.firstNameTH) || isCanEditProfile),
            isEditSurname:
              type !== USER_TYPE.AGENT &&
              (!hasValue(payload?.lastNameTH) || isCanEditProfile),
            isEditPrefix:
              type !== USER_TYPE.AGENT &&
              (!hasValue(payload?.prefix) || isCanEditProfile),
            isEditNameEN: !hasValue(payload?.firstName) || isCanEditProfile,
            isEditSurnameEN: !hasValue(payload?.lastName) || isCanEditProfile,
            isEditIdCardNo:
              !(type === USER_TYPE.AGENT || type === USER_TYPE.TEMP) &&
              (!hasValue(payload?.idCardNo) || isCanEditProfile),
            isEditMobile:
              type !== USER_TYPE.AGENT &&
              (!hasValue(payload?.mobileNo) || isCanEditProfile),
            isEditBirthDate:
              !(type === USER_TYPE.AGENT || type === USER_TYPE.TEMP) &&
              (!hasValue(payload?.dateOfBirth) || isCanEditProfile),
          }
        }

        const enrollData = {
          uuid: payload?.uuid || '',
          type,
          image: userImageUrl,
          prefixTH: payload?.prefixTH || '',
          firstNameTH: payload?.firstNameTH || '',
          lastNameTH: payload?.lastNameTH || '',
          prefix: payload?.prefix || '',
          firstName: payload?.firstName || '',
          lastName: payload?.lastName || '',
          mobileNo: payload?.mobileNo?.replace(/-/g, '') || '',
          idCardNo: payload?.idCardNo || '',
          isEdit: payload?.isEdit || false,
          birthDate: payload?.dateOfBirth || '',
          editable: editable,
          isCanEditProfile: isCanEditProfile,
        }

        state.enroll = [enrollData]
        state.formError = [[]]
        state.enrollFormError = [true]
        state.formNextButtonDisabled = [true]
      })
      .addCase(fetchMyEnrollProfile.rejected, (state, action) => {
        state.error = action.meta?.message
      })
  },
})

export const {
  setProgress,
  resetEnrollData,
  setEnrollData,
  setSocketId,
  resetData,
  setRegistrationData,
  setFormNextButtonDisabled,
  setReduxValue,
  setOptions,
  setEnrollFormError,
  setFormError,
  addEnroll,
  removeEnroll,
  setEnrollDetail,
  setImage,
  setConsent,
  removeIdcard,
} = classEnroll.actions

export default classEnroll.reducer
